import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
// Import the en-gb locale
import 'dayjs/locale/en-gb';

// Extend dayjs with plugins
dayjs.extend(relativeTime);

// Set the default locale to en-gb
dayjs.locale('en-gb');

export default dayjs;
